
export default function Footer() {
  const services = [
    'Structural Steel Welding',
    'Custom Metal Fabrication',
    'Mobile Welding Repair',
    'Heavy Equipment Repair',
    'CNC Plasma & Torch Cutting',
    'Custom Gates & Fencing',
    'AG Equipment Fabrication',
    'Staircases & Handrails',
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="contact" className="bg-[#1A1A1A] text-white">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <img
              src="https://static.wixstatic.com/media/163680_ea15eaa1c2a94dfb89bebd1cd017303d~mv2.png/v1/fill/w_130,h_129,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/New-Generation-Welding-Logo-08.png"
              alt="New Generation Welding Logo"
              title="New Generation Welding & Fabrication"
              className="h-16 w-auto mb-4"
            />
            <p className="text-white/50 text-xs leading-relaxed mb-4 font-body">
              Licensed welding contractor serving general contractors, builders, and project managers across Northern &amp; Southern California with structural steel welding, custom fabrication, and mobile welding services.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-[#E8740C] rounded-md transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-base"></i>
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-[#E8740C] rounded-md transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-base"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-bold text-sm tracking-wider text-[#E8740C] mb-5 uppercase">
              <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }} className="cursor-pointer hover:text-[#d16a0b] transition-colors">Our Services</a>
            </h4>
            <ul className="space-y-2.5">
              {services.map((service) => (
                <li key={service}>
                  <a
                    href="#request-quote"
                    onClick={(e) => { e.preventDefault(); scrollToSection('request-quote'); }}
                    className="text-white/50 text-xs hover:text-[#E8740C] transition-colors cursor-pointer"
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-sm tracking-wider text-[#E8740C] mb-5 uppercase">
              <a href="#who-we-are" onClick={(e) => { e.preventDefault(); scrollToSection('who-we-are'); }} className="cursor-pointer hover:text-[#d16a0b] transition-colors">Company</a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: 'About Us', id: 'who-we-are' },
                { label: 'Why Choose Us', id: 'why-choose-us' },
                { label: 'Project Portfolio', id: 'gallery' },
                { label: 'Request a Quote', id: 'request-quote' },
                { label: 'Contact', id: 'contact' },
              ].map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    onClick={(e) => { e.preventDefault(); scrollToSection(link.id); }}
                    className="text-white/50 text-xs hover:text-[#E8740C] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-sm tracking-wider text-[#E8740C] mb-5 uppercase">
              <a href="tel:5308068659" className="cursor-pointer hover:text-[#d16a0b] transition-colors">Contact Us</a>
            </h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-md flex-shrink-0 mt-0.5">
                  <i className="ri-phone-fill text-[#E8740C] text-sm"></i>
                </div>
                <div>
                  <p className="text-white/40 text-xs mb-0.5">Phone</p>
                  <a href="tel:5308068659" className="text-white text-sm font-medium cursor-pointer hover:text-[#E8740C] transition-colors">530-806-8659</a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-md flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-fill text-[#E8740C] text-sm"></i>
                </div>
                <div>
                  <p className="text-white/40 text-xs mb-0.5">Location</p>
                  <p className="text-white text-sm font-medium">Yuba County, California</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-md flex-shrink-0 mt-0.5">
                  <i className="ri-time-fill text-[#E8740C] text-sm"></i>
                </div>
                <div>
                  <p className="text-white/40 text-xs mb-0.5">Hours</p>
                  <p className="text-white text-sm font-medium">24/7 Emergency Available</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">
            &copy; 2025 New Generation Welding &amp; Fabrication. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-white/40 text-xs hover:text-white/60 transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
